export enum CouponTypeId {
  CAMPAIGN = '1',
  LOYALTY = '2',
  ONE_USE = '3'
}
